// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { FaEdit, FaSave } from "react-icons/fa";
// import {
//     getDeliveryBillingAPI,
//     saveOrUpdateDeliveryBillingAPI,
// } from "../../../Servicefile/SettingsAndControlService.jsx";
// const DeliveryBillingcharges = () => {

//     const promotionFields = [
//         { label: "Approach Fee Charge ", key: "approachFeePerKm" },
//         { label: "Delivery Fee Charge ", key: "deliveryFeePerKm" },
//         { label: "Maximum Distance K/M ", key: "maxDistanceKm" },

//     ];

//     const [data, setData] = useState({});
//     const [editMode, setEditMode] = useState({});

//     useEffect(() => {
//         fetchData();
//     }, []);

//     const fetchData = async () => {
//         try {
//             const result = await getDeliveryBillingAPI();

//             setData(result || {});
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     const toggleEdit = (key) => {
//         setEditMode(prev => ({ ...prev, [key]: !prev[key] }));
//     };

//     const handleChange = (key, value) => {
//         setData(prev => ({
//             ...prev,
//             [key]: value
//         }));
//     };

//     const handleSave = async (key) => {
//         try {
//             await saveOrUpdateDeliveryBillingAPI(
//                 data,
//                 key
//             );

//             toggleEdit(key);

//             fetchData();

//         } catch (err) {
//             console.error(err);

//             alert("Failed to save");
//         }
//     };

//     const renderTable = () => (
//         <div style={{
//             marginTop: '10px',
//             border: '1px solid #ddd',
//             borderRadius: '4px',
//             overflow: 'hidden',
//             maxHeight: '450px'
//         }}>

//             <div style={{ maxHeight: "400px", overflowY: "auto" }}>
//                 <table style={{ width: "100%", borderCollapse: "collapse" }}>

//                     {/* ✅ HEADER */}
//                     <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
//                         <tr>
//                             <th style={{ ...headerStyle, width: "50%" }}>Charge Type</th>
//                             <th style={{ ...headerStyle, width: "25%" }}>Value</th>
//                             <th style={{ ...headerStyle, width: "25%" }}>Actions</th>
//                         </tr>
//                     </thead>

//                     {/* ✅ BODY */}
//                     <tbody>
//                         {promotionFields.map(({ label, key }, index) => (
//                             <tr key={key} style={{
//                                 backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
//                             }}>
//                                 <td style={{ ...cellStyle, width: "50%" }}>
//                                     <strong>{label}</strong>
//                                 </td>

//                                 <td style={{ ...cellStyle, width: "25%" }}>
//                                     {editMode[key] ? (
//                                         <input
//                                             type="number"
//                                             value={data[key] ?? ""}
//                                             onChange={(e) => handleChange(key, e.target.value)}
//                                             style={inputStyle}
//                                         />
//                                     ) : (
//                                         <span>{data[key] ?? "—"}</span>
//                                     )}
//                                 </td>

//                                 <td style={{ ...cellStyle, width: "25%" }}>
//                                     {editMode[key] ? (
//                                         <FaSave
//                                             onClick={() => handleSave(key)}
//                                             style={{ ...iconStyle, color: "#4caf50" }}
//                                         />
//                                     ) : (
//                                         <FaEdit
//                                             onClick={() => toggleEdit(key)}
//                                             style={iconStyle}
//                                         />
//                                     )}
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>

//                 </table>
//             </div>
//         </div>


//     );

//     return (
//         <div >
//             {renderTable()}
//         </div>
//     );
// };

// const headerStyle = {
//     background: "rgb(230 109 51)",
//     color: "#fff",
//     padding: "12px",
//     border: "1px solid #ddd",
//     textAlign: "center"
// };

// const cellStyle = {
//     padding: "12px",
//     border: "1px solid #ddd",
//     textAlign: "center"
// };

// const inputStyle = {
//     width: "90px",
//     padding: "5px",
//     border: "1px solid #ccc",
//     borderRadius: "5px",
//     textAlign: "center"
// };

// const iconStyle = {
//     fontSize: "20px",
//     cursor: "pointer"
// };

// export default DeliveryBillingcharges;




import React, { useState, useEffect } from "react";
import { FaEdit, FaSave, FaSpinner, FaCheckCircle, FaTruck, FaRoute, FaRuler } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import {
    getDeliveryBillingAPI,
    saveOrUpdateDeliveryBillingAPI,
} from "../../../Servicefile/SettingsAndControlService.jsx";

// ─── Premium Loader ──────────────────────────────────────────────
const PremiumLoader = ({ loading, fadeOut, text = "Loading..." }) => {
    if (!loading) return null;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: fadeOut ? 0 : 1 }}
            transition={{ duration: 0.5 }}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(255, 248, 240, 0.96)',
                backdropFilter: 'blur(16px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 999999,
                fontFamily: "'Inter', 'Segoe UI', sans-serif",
                pointerEvents: fadeOut ? 'none' : 'auto',
            }}
        >
            <div style={{ textAlign: 'center', maxWidth: 400, padding: '0 20px' }}>
                <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                >
                    <div style={{
                        fontSize: '2.8rem',
                        fontWeight: 800,
                        letterSpacing: '6px',
                        marginBottom: '28px',
                        background: 'linear-gradient(135deg, #e67e22, #f39c12, #e67e22)',
                        backgroundSize: '200% 200%',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        animation: 'gradientMove 3s ease-in-out infinite',
                    }}>
                        MAAMAAS
                    </div>
                </motion.div>

                <div style={{ position: 'relative', width: 70, height: 70, margin: '0 auto 20px' }}>
                    <svg width="70" height="70" viewBox="0 0 70 70">
                        <circle
                            cx="35" cy="35" r="28"
                            fill="none"
                            stroke="rgba(230, 126, 34, 0.15)"
                            strokeWidth="4"
                        />
                        <motion.circle
                            cx="35" cy="35" r="28"
                            fill="none"
                            stroke="url(#loaderGrad)"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeDasharray="176"
                            initial={{ strokeDashoffset: 176 }}
                            animate={{ strokeDashoffset: 0 }}
                            transition={{
                                duration: 1.6,
                                ease: "easeInOut",
                                repeat: Infinity,
                            }}
                        />
                        <defs>
                            <linearGradient id="loaderGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#e67e22" />
                                <stop offset="100%" stopColor="#f39c12" />
                            </linearGradient>
                        </defs>
                    </svg>
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: '#e67e22',
                        fontSize: '11px',
                        fontWeight: 700,
                    }}>
                        <FaSpinner style={{ animation: 'spin 1s linear infinite', fontSize: 18 }} />
                    </div>
                </div>

                <motion.p
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    style={{
                        color: '#7f6b5d',
                        fontSize: '13px',
                        letterSpacing: '0.3px',
                        fontWeight: 500,
                    }}
                >
                    {text}
                </motion.p>
            </div>

            <style>{`
                @keyframes gradientMove {
                    0% { background-position: 0% 50%; }
                    50% { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                }
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </motion.div>
    );
};

// ─── Custom Hook ────────────────────────────────────────────────
const usePremiumLoader = () => {
    const [loading, setLoading] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);

    const showLoader = () => {
        setFadeOut(false);
        setLoading(true);
    };

    const hideLoader = () => {
        setFadeOut(true);
        setTimeout(() => {
            setLoading(false);
            setFadeOut(false);
        }, 500);
    };

    return { showLoader, hideLoader, loading, fadeOut };
};

// ─── Main Component ─────────────────────────────────────────────
const DeliveryBillingcharges = () => {
    const deliveryFields = [
        { label: "Approach Fee Charge", key: "approachFeePerKm", icon: <FaRoute />, unit: "₹/km" },
        { label: "Delivery Fee Charge", key: "deliveryFeePerKm", icon: <FaTruck />, unit: "₹/km" },
        { label: "Maximum Distance", key: "maxDistanceKm", icon: <FaRuler />, unit: "km" },
    ];

    const [data, setData] = useState({});
    const [editMode, setEditMode] = useState({});
    const [saving, setSaving] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [hoveredRow, setHoveredRow] = useState(null);
    const [savingKey, setSavingKey] = useState(null);

    const { showLoader, hideLoader, loading: globalLoading, fadeOut } = usePremiumLoader();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            showLoader();
            const result = await getDeliveryBillingAPI();
            setData(result || {});
        } catch (err) {
            console.error("❌ Error fetching data:", err);
        } finally {
            hideLoader();
        }
    };

    const toggleEdit = (key) => {
        setEditMode(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const handleChange = (key, value) => {
        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleSave = async (key) => {
        setSavingKey(key);
        setSaving(true);
        setSaveSuccess(false);

        try {
            await saveOrUpdateDeliveryBillingAPI(data, key);
            setSaveSuccess(true);
            setTimeout(() => setSaveSuccess(false), 3000);
            toggleEdit(key);
            await fetchData();
        } catch (err) {
            console.error("❌ Error saving:", err);
            alert(`Failed to save: ${err.response?.data?.message || err.message}`);
        } finally {
            setSaving(false);
            setSavingKey(null);
        }
    };

    const getIconForField = (label) => {
        if (label.includes("Approach")) return <FaRoute />;
        if (label.includes("Delivery")) return <FaTruck />;
        if (label.includes("Maximum")) return <FaRuler />;
        return <FaTruck />;
    };

    const getUnitForField = (label) => {
        if (label.includes("Maximum")) return "km";
        return "₹/km";
    };

    return (
        <div style={containerStyle}>
            <PremiumLoader loading={globalLoading} fadeOut={fadeOut} text="Loading delivery billing data..." />

            {/* Header */}
            <motion.div
                initial={{ opacity: 0, y: -15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                style={headerStyle}
            >
                
            </motion.div>

            {/* Table Card */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.1 }}
                style={cardStyle}
            >
                <div style={tableWrapperStyle}>
                    {/* Header Row */}
                    <div style={headerRowStyle}>
                        <div style={{ ...headerCellStyle, width: '45%', textAlign: 'left', paddingLeft: 24 }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <FaTruck size={14} />
                                Charge Type
                            </span>
                        </div>
                        <div style={{ ...headerCellStyle, width: '25%', textAlign: 'center' }}>Value</div>
                        <div style={{ ...headerCellStyle, width: '30%', textAlign: 'right', paddingRight: 24 }}>Action</div>
                    </div>

                    {/* Body */}
                    <div style={bodyScrollStyle}>
                        {deliveryFields.map(({ label, key }, index) => {
                            const isEditing = editMode[key];
                            const isHovered = hoveredRow === key;
                            const isSaving = savingKey === key && saving;
                            const value = data[key] !== undefined && data[key] !== null ? data[key] : "";
                            const unit = getUnitForField(label);
                            const icon = getIconForField(label);

                            return (
                                <motion.div
                                    key={key}
                                    initial={{ opacity: 0, x: -8 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.25, delay: index * 0.06 }}
                                    onMouseEnter={() => setHoveredRow(key)}
                                    onMouseLeave={() => setHoveredRow(null)}
                                    style={{
                                        ...rowStyle,
                                        background: isHovered ? '#fef9f4' : (index % 2 === 0 ? '#ffffff' : '#fcf9f7'),
                                    }}
                                >
                                    {/* Charge Type */}
                                    <div style={{ ...cellStyle, width: '45%', justifyContent: 'flex-start', paddingLeft: 24 }}>
                                        <span style={iconStyleSmall}>
                                            {icon}
                                        </span>
                                        <span style={labelStyle}>{label}</span>
                                    </div>

                                    {/* Value */}
                                    <div style={{ ...cellStyle, width: '25%' }}>
                                        {isEditing ? (
                                            <div style={inputWrapperStyle}>
                                                <input
                                                    type="number"
                                                    value={value}
                                                    onChange={(e) => handleChange(key, e.target.value)}
                                                    style={inputStyle}
                                                    step="0.01"
                                                    min="0"
                                                    autoFocus
                                                    placeholder="0.00"
                                                />
                                                <span style={unitStyle}>{unit}</span>
                                            </div>
                                        ) : (
                                            <span style={valueStyle}>
                                                {value !== "" && value !== null && value !== undefined
                                                    ? `${Number(value).toFixed(2)} ${unit}`
                                                    : "—"
                                                }
                                            </span>
                                        )}
                                    </div>

                                    {/* Actions */}
                                    <div style={{ ...cellStyle, width: '30%', justifyContent: 'flex-end', paddingRight: 24, gap: 10 }}>
                                        {isEditing ? (
                                            <motion.button
                                                whileHover={{ scale: 1.03 }}
                                                whileTap={{ scale: 0.95 }}
                                                onClick={() => handleSave(key)}
                                                style={{ ...actionBtnStyle, background: '#e67e22' }}
                                                disabled={isSaving}
                                            >
                                                {isSaving ? (
                                                    <>
                                                        <FaSpinner style={{ animation: 'spin 1s linear infinite' }} size={14} />
                                                        <span>Saving</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaSave size={14} />
                                                        <span>Save</span>
                                                    </>
                                                )}
                                            </motion.button>
                                        ) : (
                                            <motion.button
                                                whileHover={{ scale: 1.03 }}
                                                whileTap={{ scale: 0.95 }}
                                                onClick={() => toggleEdit(key)}
                                                style={{ ...actionBtnStyle, background: '#f39c12' }}
                                            >
                                                <FaEdit size={14} />
                                                <span>Edit</span>
                                            </motion.button>
                                        )}
                                    </div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>

                {/* Footer */}
                <div style={footerStyle}>
                    <div style={footerLeftStyle}>
                        {saveSuccess && (
                            <motion.div
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                style={successBadgeStyle}
                            >
                                <FaCheckCircle color="#e67e22" size={18} />
                                <span>Changes saved successfully!</span>
                            </motion.div>
                        )}
                        
                    </div>
                </div>
            </motion.div>

            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.4; }
                }
                * { box-sizing: border-box; }
                ::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                ::-webkit-scrollbar-track {
                    background: #f5f0eb;
                    border-radius: 10px;
                }
                ::-webkit-scrollbar-thumb {
                    background: #e67e22;
                    border-radius: 10px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: #d35400;
                }
            `}</style>
        </div>
    );
};

// ─── Premium Orange Theme Styles ──────────────────────────────

const containerStyle = {
  
    minHeight: "100vh",
};

const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 12,
};

const headerLeftStyle = {
    display: "flex",
    alignItems: "center",
    gap: 16,
};

const headerIconWrapper = {
    width: 48,
    height: 48,
    borderRadius: 14,
    background: "rgba(230, 126, 34, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const headerTitleStyle = {
    fontSize: "clamp(1.3rem, 3vw, 1.8rem)",
    fontWeight: 700,
    color: "#e66d33",
    letterSpacing: "-0.3px",
    margin: 0,
    lineHeight: 1.2,
};

const headerSubStyle = {
    fontSize: "clamp(12px, 1vw, 14px)",
    color: "#8a7a6e",
    margin: "2px 0 0 0",
    fontWeight: 400,
};

const headerBadgeStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "rgba(230, 126, 34, 0.08)",
    padding: "6px 18px",
    borderRadius: 100,
    border: "1px solid rgba(230, 126, 34, 0.15)",
};

const badgeDotStyle = {
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: "#e67e22",
    display: "inline-block",
    animation: "pulse 2s infinite",
};

const badgeTextStyle = {
    fontSize: "13px",
    fontWeight: 600,
    color: "#e67e22",
};

const cardStyle = {
    background: "#ffffff",
    borderRadius: 18,
    boxShadow: "0 8px 40px rgba(0,0,0,0.05), 0 2px 12px rgba(0,0,0,0.03)",
    overflow: "hidden",
    border: "1px solid rgba(230, 126, 34, 0.06)",
};

const tableWrapperStyle = {
    overflow: "hidden",
};

const headerRowStyle = {
    display: "flex",
    background: "linear-gradient(135deg, #e66d33, #e66d33)",
    padding: "0 4px",
    borderBottom: "3px solid #e67e22",
};

const headerCellStyle = {
    padding: "14px 12px",
    color: "#ffffff",
    fontWeight: 800,
    fontSize: "clamp(11px, 0.9vw, 13px)",
    textTransform: "uppercase",
    letterSpacing: "0.4px",
    flexShrink: 0,
  
};

const bodyScrollStyle = {
    maxHeight: "340px",
    overflowY: "auto",
    padding: "0 4px",
};

const rowStyle = {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #f0ebe6",
    padding: "8px 0",
    transition: "all 0.2s ease",
    borderRadius: 4,
    margin: "2px 0",
};

const cellStyle = {
    padding: "6px 12px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontSize: "clamp(12px, 0.9vw, 14px)",
    gap: 10,
    minHeight: 44,
};

const iconStyleSmall = {
    fontSize: "clamp(15px, 1.1vw, 18px)",
    opacity: 0.6,
    color: "#e67e22",
};

const labelStyle = {
    fontWeight: 500,
    color: "#3d241a",
    fontSize: "clamp(12px, 0.9vw, 14px)",
};

const valueStyle = {
    fontWeight: 600,
    color: "#3d241a",
    fontSize: "clamp(13px, 0.95vw, 14px)",
};

const inputWrapperStyle = {
    display: "flex",
    alignItems: "center",
    gap: 6,
};

const inputStyle = {
    width: "90px",
    padding: "6px 10px",
    border: "2px solid #e67e22",
    borderRadius: 8,
    fontSize: "clamp(12px, 0.9vw, 14px)",
    fontWeight: 500,
    textAlign: "center",
    background: "#fffaf5",
    outline: "none",
    transition: "all 0.2s",
    color: "#e66d33",
};

const unitStyle = {
    fontSize: "clamp(11px, 0.8vw, 12px)",
    color: "#8a7a6e",
    fontWeight: 500,
};

const actionBtnStyle = {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 18px",
    border: "none",
    borderRadius: 8,
    color: "#fff",
    fontWeight: 600,
    fontSize: "clamp(11px, 0.85vw, 13px)",
    cursor: "pointer",
    transition: "all 0.2s",
    boxShadow: "0 3px 12px rgba(230, 126, 34, 0.2)",
    letterSpacing: "0.3px",
    minWidth: 80,
    justifyContent: "center",
};

const footerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 24px",
    borderTop: "1px solid #f0ebe6",
    background: "#fcf9f7",
    flexWrap: "wrap",
    gap: 10,
};

const footerLeftStyle = {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap",
};

const successBadgeStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "rgba(230, 126, 34, 0.1)",
    padding: "4px 14px",
    borderRadius: 100,
    fontSize: "clamp(12px, 0.9vw, 13px)",
    fontWeight: 500,
    color: "#e67e22",
};

const footerCountStyle = {
    fontSize: "clamp(11px, 0.8vw, 12px)",
    color: "#b0a094",
    fontWeight: 400,
};

// ─── Responsive Inject ──────────────────────────────────────────

const responsiveStyles = `
    @media (max-width: 820px) {
        .row-style, .header-row {
            flex-wrap: wrap;
            padding: 10px 4px;
        }
        .cell-style, .header-cell-style {
            width: 50% !important;
            justify-content: center;
            padding: 4px 6px;
            font-size: 12px;
            min-height: 38px;
        }
        .cell-style:last-child, .header-cell-style:last-child {
            width: 100% !important;
            justify-content: center !important;
            padding-right: 6px !important;
            padding-left: 6px !important;
        }
        .action-btn {
            padding: 5px 12px;
            font-size: 11px;
            min-width: 60px;
        }
        .action-btn span {
            display: inline;
        }
        .input-style {
            width: 70px;
            padding: 4px 6px;
            font-size: 12px;
        }
        .footer-style {
            flex-direction: column;
            align-items: stretch;
            text-align: center;
            padding: 12px 16px;
        }
        .footer-left {
            justify-content: center;
        }
    }
    @media (max-width: 500px) {
        .container-style {
            padding: 12px 8px;
        }
        .header-style {
            flex-direction: column;
            align-items: flex-start;
        }
        .header-title {
            font-size: 1.1rem;
        }
        .header-sub {
            font-size: 11px;
        }
        .cell-style, .header-cell-style {
            font-size: 11px;
            padding: 2px 4px;
            min-height: 34px;
            gap: 4px;
        }
        .icon-small {
            font-size: 13px !important;
        }
        .label-style {
            font-size: 11px !important;
        }
        .value-style {
            font-size: 12px !important;
        }
        .input-style {
            width: 55px;
            padding: 3px 4px;
            font-size: 11px;
        }
        .unit-style {
            font-size: 10px !important;
        }
        .action-btn {
            padding: 4px 10px;
            font-size: 10px;
            gap: 4px;
            min-width: 50px;
        }
        .action-btn span {
            display: none;
        }
        .action-btn svg {
            font-size: 13px;
        }
        .footer-count {
            font-size: 10px;
        }
        .success-badge {
            font-size: 11px;
            padding: 2px 10px;
        }
        .header-icon-wrapper {
            width: 38px;
            height: 38px;
        }
        .header-badge {
            padding: 4px 12px;
        }
    }
`;

const styleTag = document.createElement("style");
styleTag.textContent = responsiveStyles;
document.head.appendChild(styleTag);

export default DeliveryBillingcharges;